import { Box } from '@mui/material';

const PublicRoute = ({ children }: any) => {
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{children}</Box>
    </>
  );
};

export default PublicRoute;
